import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
} from "@material-tailwind/react";

import { XMarkIcon } from "@heroicons/react/24/solid";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getNotificationLogs } from "@/store/slices/appointmentSlice";
import { useTranslation } from "react-i18next";

export default function CustomerNotificationLogModal({
    open,
    onClose,
    appointment
}) {

    const { t } = useTranslation('appointment');

    const dispatch = useDispatch();
    const { notificationLogs } = useSelector((state) => state.appointment);
    const logs = notificationLogs?.data || [];
    useEffect(() => {
        if(!appointment?.id)return;
        dispatch(getNotificationLogs(appointment?.id));
    }, [dispatch, appointment]);

    return (
        <Dialog
            open={open}
            handler={onClose}
            size="md"
            className="rounded-xl"
        >
            <DialogHeader className="border-b flex justify-between items-center">
                <Typography variant="h5" className="font-semibold">
                    {t("title4")}
                </Typography>

                <XMarkIcon
                    onClick={onClose}
                    className="h-6 w-6 cursor-pointer text-gray-700"
                />
            </DialogHeader>

            <DialogBody className="max-h-[70vh] overflow-y-auto">
                {logs.length > 0 ? (
                    <div className="space-y-4">
                        {logs.map((log) => (
                            <div
                                key={log.id}
                                className="border rounded-lg p-4 bg-gray-50"
                            >
                                <div className="flex justify-between items-start gap-3">
                                    <div>
                                        <p className="font-medium text-gray-900">
                                            {log.subject}
                                        </p>

                                        <p className="text-sm text-gray-600 mt-1">
                                            {t("recipientLabel")}: {log.recipient_email}
                                        </p>

                                        <p className="text-sm text-gray-500">
                                            {t("typeLabel")}: {log.type}
                                        </p>
                                    </div>

                                    <span className="text-xs text-gray-500 whitespace-nowrap">
                                        {moment(log.created_at).format(
                                            "DD MMM YYYY, hh:mm A"
                                        )}
                                    </span>
                                </div>

                                <div className="mt-3 flex flex-wrap gap-2">
                                    <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-700 capitalize">
                                        {log.type}
                                    </span>

                                    {/* <span
                                        className={`px-2 py-1 text-xs rounded-full capitalize ${
                                            log.status === "sent"
                                                ? "bg-green-100 text-green-700"
                                                : log.status === "failed"
                                                ? "bg-red-100 text-red-700"
                                                : "bg-yellow-100 text-yellow-700"
                                        }`}
                                    >
                                        {log.status}
                                    </span> */}
                                </div>

                                {log.sent_at && (
                                    <p className="mt-2 text-xs text-gray-500">
                                        {t("sentAtLabel")} {" "}
                                        {moment(log.sent_at).format(
                                            "DD MMM YYYY, hh:mm A"
                                        )}
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="py-10 text-center">
                        <Typography color="gray">
                           {t("noLogsFound")}
                        </Typography>
                    </div>
                )}
            </DialogBody>

            <DialogFooter className="border-t">
                <Button
                    variant="outlined"
                    color="gray"
                    onClick={onClose}
                >
                    {t("closeButton")}
                </Button>
            </DialogFooter>
        </Dialog>
    );
}